module.exports = __webpack_public_path__ + "assets/img/rule-1.0a2b949e.png";